import {create} from "zustand";

type HelpTourUiStore = {
  active: boolean;
  stepIndex: number;
  total: number;
  startTour: (stepIndex: number, total: number) => void;
  setProgress: (stepIndex: number, total: number) => void;
  endTour: () => void;
};

export const useHelpTourUiStore = create<HelpTourUiStore>((set) => ({
  active: false,
  stepIndex: 0,
  total: 0,
  startTour: (stepIndex, total) => set({active: true, stepIndex, total}),
  setProgress: (stepIndex, total) => set({stepIndex, total}),
  endTour: () => set({active: false, stepIndex: 0, total: 0}),
}));
